import React, { useContext } from 'react';
import { SurveyPageContext } from '../context/SurveyPageContext';
import styles from './ProgressBar.module.css';

const ProgressBar: React.FunctionComponent = () => {
  const { paginatedSurvey, surveyPage } = useContext(SurveyPageContext);
  const pagesString = `${surveyPage} of ${paginatedSurvey.size}`;
  const width = (surveyPage / paginatedSurvey.size) * 100;

  return (
    <div className={styles.progressBarContainer}>
      <div className={styles.barWrapper}>
        <div className={styles.progressBar} />
        <div className={styles.progressBarCompletion} style={{ width: `${width}%` }} />
      </div>
      <div className={styles.pages}>{pagesString}</div>
    </div>
  );
};

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
